export { CountdownTimer } from './ui';
import * as model from './model';

export const countdownTimer = {
  model,
};
